import React from "react";
import SessionExpiredAlert from "../SessionExpiredAlert";

export default props => (
  <div className="cb-c-banner-stack">
    <SessionExpiredAlert />
    {props.children}
  </div>
);
